export default "__VITE_ASSET__DCoiseW5__"